export enum VideoPlayerTypes {
  YOUTUBE = 'YOUTUBE',
  VIMEO = 'VIMEO',
  NATIVE = 'NATIVE',
}
